import React, {  ChangeEvent, useEffect, useState } from 'react';
import { graphql, navigate } from "gatsby"
import Layout from "../components/layout"
import Modal from "react-modal";
import { Tab } from '@headlessui/react'
import { Disclosure } from '@headlessui/react'
import { Popover } from '@headlessui/react'
import { ChevronUpIcon } from '@heroicons/react/20/solid'
import { Link } from "gatsby"
import SEO from "../components/seo"
import { GatsbyImage, getImage,StaticImage } from "gatsby-plugin-image"
import { Swiper, SwiperSlide} from 'swiper/react';
import {  Navigation, Mousewheel, Keyboard, FreeMode, Thumbs } from 'swiper/modules';
import axios from 'axios';
import { Helmet } from 'react-helmet'
import Extras from "../components/general/extras"
import ChatButton from "../components/general/chatButton"
import emailjs from 'emailjs-com';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import "swiper/css/free-mode";
import "swiper/css/thumbs";

const RatingItem = ({ title, percentage, average, svgPath }) => {
  const getColor = (average) => {
    if (average >= 4.5) {
      return { text: "Fenomenaal", color: "text-green-700" }; // Donkergroen
    } else if (average >= 4.0) {
      return { text: "Fantastisch", color: "text-green-500" }; // Lichtgroen
    } else if (average >= 3.0) {
      return { text: "Goed", color: "text-yellow-400" }; // Geel
    } else if (average >= 2.0) {
      return { text: "Kan beter", color: "text-orange-400" }; // Oranje
    } else {
      return { text: "Raad ik niet aan", color: "text-red-400" }; // Rood
    }
  };




  return (
    <div className="bg-sky-100 rounded-lg p-2 flex items-center">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2 inline">
        <path strokeLinecap="round" strokeLinejoin="round" d={svgPath} />
      </svg>
      <span className="w-32">{title}</span>
      <div className="flex-1 h-2 bg-sky-400 rounded-lg ml-2">
        <div className="h-2 bg-sky-600 rounded-lg" style={{ width: `${percentage}%` }}></div>
      </div>
      {/* <span className={`ml-4 rounded-full  p-2 text-sm font-bold`}>{average}</span> */}
    </div>
  );  
};



const SurfvakantieTemplate = ({ data: { wpSurfvakantie, allWpSurfvakantie,allAirtable, defaultSurfvakantie }, pageContext, location }) => {
const { title, surfvakantieNieuw, featuredImage, author } = wpSurfvakantie;
const { lang } = pageContext; 





const imageOne = `https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(featuredImage.node.publicUrl)}&format=webp&w=600&h=400&fit=crop`;

const imageTwo = `https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(surfvakantieNieuw.gallery1[0].publicUrl)}&format=webp&w=600&h=400&fit=crop`;
const imageThree = `https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(surfvakantieNieuw.gallery1[1].publicUrl)}&format=webp&w=600&h=400&fit=crop`;
const imageFour = `https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(surfvakantieNieuw.gallery1[2].publicUrl)}&format=webp&w=600&h=400&fit=crop`;
const imageFive = `https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(surfvakantieNieuw.gallery1[3].publicUrl)}&format=webp&w=600&h=400&fit=crop`;
const imageSix = `https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(surfvakantieNieuw.gallery1[4].publicUrl)}&format=webp&w=600&h=400&fit=crop`;
const imageSeven = `https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(surfvakantieNieuw.gallery1[5].publicUrl)}&format=webp&w=600&h=400&fit=crop`;

const imageUrl = wpSurfvakantie.featuredImage?.node?.link



const [discountNaam, setNaam] = useState("");
const [discountEmail, setEmailadres] = useState("");


useEffect(() => {
  // Controleer of je in de browseromgeving bent
  if (typeof window !== "undefined") {
    emailjs.init("i9ZCMSRVkQYF5ttVY"); // Voeg hier je User ID toe
  }
}, []);


const handleSubmit = (e) => {
  e.preventDefault();

  const templateParams = {
    discountNaam,
    discountEmail,
  };

  emailjs
    .send("service_d8hzikh", "template_2y4bfpm", templateParams, "i9ZCMSRVkQYF5ttVY")
    .then(
      (response) => {
        console.log("Succes!", response.status, response.text);
        alert("E-mail succesvol verzonden!");
      },
      (error) => {
        console.error("Er is een fout opgetreden:", error);
        alert("Er is een fout opgetreden bij het verzenden van de e-mail.");
      }
    );
}


// START WP REVIEW // 

// const reviews = allWpReview.edges
// let numberReviews = reviews.length

// // Accommodation
// let ratingAccommodation = 0
// let countAccommodation = 0

// for (let i in reviews) {
//   let value = parseFloat(reviews[i].node.reviews.rateAccommodation)
//   ratingAccommodation += value
//   countAccommodation++
// }

// ratingAccommodation = ratingAccommodation / countAccommodation



// const [accommodationScore, setAccommodationScore] = useState(ratingAccommodation); // set initial score to 3 out of 5
// const accommodationPercentage = (accommodationScore / 5) * 100; // calculate percentage value


// // Atmosphere
// let ratingAtmosphere = 0
// let countAtmosphere = 0

// for (let i in reviews) {
//   let value = parseFloat(reviews[i].node.reviews.rateAtmosphere)
//   ratingAtmosphere += value
//   countAtmosphere++
// }

// ratingAtmosphere = ratingAtmosphere / countAtmosphere

// const [atmosphereScore, setAtmosphereScore] = useState(ratingAtmosphere); // set initial score to 3 out of 5
// const atmospherePercentage = (accommodationScore / 5) * 100; // calculate percentage value



// // Food
// let ratingPriceQuality = 0
// let countPriceQuality = 0

// for (let i in reviews) {
//   let value = parseFloat(reviews[i].node.reviews.ratePriceQuality)
//   ratingPriceQuality += value
//   countPriceQuality++
// }

// ratingPriceQuality = ratingPriceQuality / countPriceQuality

// const [priceQualityScore, setPriceQualityScore] = useState(ratingPriceQuality); // set initial score to 3 out of 5
// const priceQualityPercentage = (priceQualityScore / 5) * 100; // calculate percentage value


// // Location
// let ratingLocation = 0
// let countLocation = 0

// for (let i in reviews) {
//   let value = parseFloat(reviews[i].node.reviews.rateLocation)
//   ratingLocation += value
//   countLocation++
// }

// ratingLocation = ratingLocation / countLocation

// const [locationScore, setLocationScore] = useState(ratingLocation); // set initial score to 3 out of 5
// const locationPercentage = (locationScore / 5) * 100; // calculate percentage value




// // Staff
// let ratingStaff = 0
// let countStaff = 0

// for (let i in reviews) {
//   let value = parseFloat(reviews[i].node.reviews.rateStaff)
//   ratingStaff += value
//   countStaff++
// }

// ratingStaff = ratingStaff / countStaff

// const [staffScore, setStaffScore] = useState(ratingStaff); // set initial score to 3 out of 5
// const staffPercentage = (staffScore / 5) * 100; // calculate percentage value



// // Surf Lessons
// let ratingSurfLessons = 0
// let countSurfLessons = 0

// for (let i in reviews) {
//   let value = parseFloat(reviews[i].node.reviews.rateSurfLessons)
//   ratingSurfLessons += value
//   countSurfLessons++
// }

// ratingSurfLessons = ratingSurfLessons / countSurfLessons

// const [surfLessonsScore, setSurfLessonsScore] = useState(ratingSurfLessons); // set initial score to 3 out of 5
// const surfLessonsPercentage = (surfLessonsScore / 5) * 100; // calculate percentage value



// // Total

// let ratingTotal = ratingAccommodation + ratingAtmosphere + ratingPriceQuality + ratingLocation + ratingStaff + ratingSurfLessons
// let ratingCount = 6


// let rating = ratingTotal / ratingCount
// rating = +rating.toFixed(1)

// console.log(rating)
// console.log(ratingTotal)
// console.log(ratingCount)
// console.log(numberReviews)

// END WP REVIEW //

const [modalOpen, setModalOpen] = useState(false);
const [travelSpecialistModalOpen, setTravelSpecialistModalOpen] = useState(false);
const [accommodationModalOpen, setAccommodationModalOpen] = useState(false);
const [surfingModalOpen, setSurfingModalOpen] = useState(false);
const [activitiesModalOpen, setActivitiesModalOpen] = useState(false);
const [maaltijdenModalOpen, setMaaltijdenModalOpen] = useState(false);
const [thumbsSwiper, setThumbsSwiper] = useState(null);

  // Effect om body scroll te beheren
  useEffect(() => {
    const body = document.body;
    if (travelSpecialistModalOpen) {
      body.classList.add('no-scroll');
    } else {
      body.classList.remove('no-scroll');
    }

    // Opruimen wanneer de component unmount
    return () => {
      body.classList.remove('no-scroll');
    };
  }, [travelSpecialistModalOpen]); // Voer dit effect uit telkens wanneer travelSpecialistModalOpen verandert



// accommodatie
const [activeTab, setActiveTab] = useState(0);
const handleClick = (index) => {
  setActiveTab(index);
};


// surfen
const [activeSurfTab, setActiveSurfTab] = useState(0);
const handleSurfClick = (index) => {
  setActiveSurfTab(index);
};


// activiteiten
const [activeActivityTab, setActiveActivityTab] = useState(0);
const handleActivityClick = (index) => {
  setActiveActivityTab(index);
};


// maaltijden
const [activeMealTab, setActiveMealTab] = useState(0);
const handleMealClick = (index) => {
  setActiveMealTab(index);
};



// function scrolldiv() {
//   var elem = document.getElementById("beschikbaarheid");
//   elem.scrollIntoView({ behavior: "smooth", block: "start" });
// }

// function scrollPrijzen() {
//   var elem = document.getElementById("prijzen");
//   elem.scrollIntoView({ behavior: "smooth", block: "start" });
// }

// function scrollContact() {
//   var elem = document.getElementById("contact");
//   elem.scrollIntoView({ behavior: "smooth", block: "start" });
// }

const parent = '/surfvakanties/'+surfvakantieNieuw.land
const parentUri = parent.toLowerCase();


let place_id = surfvakantieNieuw.placeId

let [isOpen, setIsOpen] = useState(false)

const [naam, setName] = useState('');
const [emailadres, setEmail] = useState('');
const [telefoonnummer, setPhone] = useState('');
const accommodatie = title;
const [vraag, setQuestion] = useState('');
const [successMessage, setSuccessMessage] = useState("");

const handleDiscount = async (event) => {
    event.preventDefault();
    const data = {
      title: naam, 
      type: 'contact',
      author: 1,
      fields: {
        naam: naam,
        emailadres: emailadres,
        telefoonnummer: telefoonnummer,
        accommodatie: accommodatie,
        vraag: vraag,
        successMessage : successMessage
      }
    };
    try {
        const response = await axios.post('https://wp.surfawhile.com/wp-json/wp/v2/contact', data, {
        timeout: 60000, // Override the default timeout for this request
        headers: {
              'Authorization': `Basic ${btoa('hansvmourik:xLzc FSKE ZdLF RYF1 wVa7 CKmQ')}`,
            },
          });        
          console.log(response.data);
          setSuccessMessage("Bedankt voor het invullen van het contactformulier. Wij nemen z.s.m. contact met jou op."); // Set success message
    } catch (error) {
        console.log(error);
      }

    navigate('/thank-you'); // Replace '/thank-you' with the actual URL of your thank you page

  }

// const hasLanguageCategory = wpSurfvakantie.categories.nodes.some(category => category.name === 'language')

const type = wpSurfvakantie.surfvakantieNieuw.typeAccommodatie

const [activeIndex, setActiveIndex] = useState(0);
const totalSlides = surfvakantieNieuw.gallery2.length;

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };


const categories = wpSurfvakantie.surfvakantieNieuw.categories;

// console.log(categories)

const vergelijkbareSurfvakanties = wpSurfvakantie.surfvakantieNieuw.vergelijkbareSurfvakanties
// console.log(vergelijkbareSurfvakanties)

// if (vergelijkbareSurfvakanties && vergelijkbareSurfvakanties.length > 0) {
//   vergelijkbareSurfvakanties.map(item => {
//       console.log(item.surfvakanties.title); // Log de titel van elke surfvakantie
//   });
// } else {
//   console.log("Geen vergelijkbare surfvakanties beschikbaar");
// }

// if (vergelijkbareSurfvakanties && vergelijkbareSurfvakanties.length > 0) {
//   vergelijkbareSurfvakanties.map(item => {
//       console.log(item.surfvakanties.title); // Log de titel van elke surfvakantie
//   });
// } else {
//   console.log("Geen vergelijkbare surfvakanties beschikbaar");
// }

// const expert = wpSurfvakantie.surfvakantieNieuw.surfTravelExpert.firstName
// console.log(expert)






const link = wpSurfvakantie.link
const fullLink = `https://surfawhile.com${link}`;
const id = wpSurfvakantie.databaseId

const addDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'destinationId': `${id}`,
    'destinationName': `${wpSurfvakantie.title}`,
    'destinationCountry': `${wpSurfvakantie.surfvakantieNieuw.land}`,
    'destinationRegion': `${wpSurfvakantie.surfvakantieNieuw.inleidingRegio}`,
    'destinationCity': `${wpSurfvakantie.surfvakantieNieuw.inleidingLocatie}`,
    'destinationURL': `${fullLink}`,
    'pagetype': `product`,
    'destinationPrice': `${wpSurfvakantie.surfvakantieNieuw.inleidingPrijs}`,
    'destinationAccommodationType': `${wpSurfvakantie.surfvakantieNieuw.typeAccommodatie}`,
    'destinationRoomType': `${wpSurfvakantie.surfvakantieNieuw.inleidingTypenVerblijf}`,
  });
  console.log("DataLayer:", window.dataLayer);
};




 useEffect(() => {
    if (typeof window !== "undefined") {
      addDataLayer();
    }
  }, []);


  
const pictureMees = 'https://wp.surfawhile.com/wp-content/uploads/2024/05/109e1e63-4ecf-4821-abb3-cf82aa209ae9.jpg'
const pictureHans = 'https://wp.surfawhile.com/wp-content/uploads/2024/05/hans_avatar.jpg'
   

const accommodations = allAirtable.edges


// Bereken de gemiddelde scores
const totalReviews = accommodations.length
const totalScores = accommodations.reduce((acc, { node }) => {
  acc.Quality_Accommodation += node.data.Quality_Accommodation
  acc.Atmosphere += node.data.Atmosphere
  acc.Surf_Lessons += node.data.Surf_Lessons
  acc.Staff += node.data.Staff
  acc.Quality_Location += node.data.Quality_Location
  acc.Price_Quality += node.data.Price_Quality
  return acc
}, {
  Quality_Accommodation: 0,
  Atmosphere: 0,
  Surf_Lessons: 0,
  Staff: 0,
  Quality_Location: 0,
  Price_Quality: 0,
})

const averageScores = {
  Quality_Accommodation: (totalScores.Quality_Accommodation / totalReviews).toFixed(1),
  Atmosphere: (totalScores.Atmosphere / totalReviews).toFixed(1),
  Surf_Lessons: (totalScores.Surf_Lessons / totalReviews).toFixed(1),
  Staff: (totalScores.Staff / totalReviews).toFixed(1),
  Quality_Location: (totalScores.Quality_Location / totalReviews).toFixed(1),
  Price_Quality: (totalScores.Price_Quality / totalReviews).toFixed(1),
  Calculation: ((totalScores.Quality_Accommodation + totalScores.Atmosphere + totalScores.Surf_Lessons + totalScores.Staff + totalScores.Quality_Location + totalScores.Price_Quality) / (6 * totalReviews)).toFixed(1),
}

const average = averageScores.Calculation

let rating = average


const getColor = (average, lang) => {
  if (average >= 4.5) {
    return { 
      text: "text-green-700", 
      bg: "bg-green-700", 
      description: lang === "en" ? "Phenomenal" : "Fenomenaal" 
    }; // Donkergroen
  } else if (average >= 4.0) {
    return { 
      text: "text-green-500", 
      bg: "bg-green-500", 
      description: lang === "en" ? "Fantastic" : "Fantastisch" 
    }; // Lichtgroen
  } else if (average >= 3.0) {
    return { 
      text: "text-yellow-400", 
      bg: "bg-yellow-400", 
      description: lang === "en" ? "Good" : "Goed" 
    }; // Geel
  } else if (average >= 2.0) {
    return { 
      text: "text-orange-400", 
      bg: "bg-orange-400", 
      description: lang === "en" ? "Could be better" : "Kan beter" 
    }; // Oranje
  } else {
    return { 
      text: "text-red-400", 
      bg: "bg-red-400", 
      description: lang === "en" ? "Not recommended" : "Raad ik niet aan" 
    }; // Rood
  }
};

// Dynamisch ophalen van tekst-, achtergrondklassen en beschrijving
const { text: descriptionColor, bg: calculationBgColor, description: descriptionText } = getColor(average || 0, lang);

// console.log("Text Color:",  descriptionColor); // Verwacht: "text-green-500"
// console.log("Text:", descriptionText);   // Verwacht: "Fantastisch"
// console.log("Background color:", calculationBgColor);  // Controleer of dit een geldig getal is


// const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL3dwLnN1cmZhd2hpbGUuY29tIiwiaWF0IjoxNzI2NTYyMjcxLCJuYmYiOjE3MjY1NjIyNzEsImV4cCI6MTcyNzE2NzA3MSwiZGF0YSI6eyJ1c2VyIjp7ImlkIjoiMSJ9fX0.9Bz-1jippzjr5HH8LUhxL_eR0a-ZDqfz2pgg_xFhTmY';  // Je JWT-token
const updateACFField = async (postId, calculation, numberOfReviews) => {
  try {
    const response = await fetch(`https://wp.surfawhile.com/wp-json/wp/v2/surfvakanties/${postId}`, {
      method: 'PUT', // of 'POST', afhankelijk van wat werkt
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${process.env.GATSBY_WORDPRESS_JWT_TOKEN}`,
      },
      body: JSON.stringify({
        fields: {
          rating: calculation,
          number_of_reviews: numberOfReviews,
        },
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error details:', errorData);
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    console.log('ACF fields updated:', data);
    return data;
  } catch (error) {
    console.error('Error updating ACF fields:', error);
    throw error;
  }
};

// console.log("dreamseaEarlyBird waarde:", surfvakantieNieuw?.dreamseaEarlyBird);



// Aanroep om de rating en het aantal reviews van een surfvakantie bij te werken
const postId = wpSurfvakantie.databaseId;
const calculation = averageScores.Calculation;
const numberOfReviews = accommodations.length;
//updateACFField(postId, calculation, numberOfReviews);


// const adviseClick = () => {
//   window.Trengo.Api.Widget.open('chat');
// };

// const trengoLoaded = useTrengo(); // Gebruik de hook om te controleren of Trengo is geladen

// const handleWhatsAppClick = () => {
//   if (trengoLoaded) {
//     try {
//       console.log("Probeer WhatsApp te openen...");
      
//       const widget = document.querySelector('#trengo-web-widget');
      
//       if (widget) {
//         widget.style.visibility = 'visible'; // Maak de widget zichtbaar voor gebruik
//       }
      
//       window.Trengo.sound = false; // Zet het geluid uit
      
//       // Render en open de WhatsApp-widget
//       window.Trengo.Api.Widget.render();
//       window.Trengo.Api.Widget.open("whatsapp");
      
//       // Zorg ervoor dat de widget verborgen blijft na opening
//       setTimeout(() => {
//         if (widget) {
//           widget.style.visibility = 'hidden'; // Verberg de widget opnieuw
//         }
//       }, 500); // Wacht 500ms om er zeker van te zijn dat de widget correct opent
//     } catch (error) {
//       console.error("Fout bij het openen van WhatsApp via Trengo:", error);
//     }
//   }
// };


useEffect(() => {
  // JavaScript voor offset scrollen
  document.querySelectorAll('.anchor').forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        const yOffset = -50; // 50 pixels boven het anker
        const yPosition = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: yPosition, behavior: 'smooth' });
      }
    });
  });
}, []);


  const removeHtmlTags = (text) => {
    // Regex om alle HTML-tags te verwijderen
    return text.replace(/<[^>]*>/g, '');
  };

  // const currentUrl = typeof window !== 'undefined' ? window.location.href : '';

const [currentUrl, setCurrentUrl] = useState('');

useEffect(() => {
  if (typeof window !== 'undefined') {
    setCurrentUrl(window.location.href);
  }
}, []);


return (

  // <Layout>

<Layout className="surfvakantie-template">

<Helmet>
{`
  ${addDataLayer.toString()}
`}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LodgingBusiness",
      "name": wpSurfvakantie?.title || "Onbekende Surfvakantie",
      "description": wpSurfvakantie?.seo?.metaDesc || "Een onvergetelijke surfvakantie!",
      "image": imageUrl?.startsWith("http") ? imageUrl : wpSurfvakantie?.featuredImage?.node?.publicUrl || null,
      "address": wpSurfvakantie?.surfvakantieNieuw?.adres || wpSurfvakantie?.surfvakantieNieuw?.land
        ? {
          "@type": "PostalAddress",
          ...(wpSurfvakantie.surfvakantieNieuw?.adres && { "streetAddress": wpSurfvakantie.surfvakantieNieuw.adres }),
          ...(wpSurfvakantie.surfvakantieNieuw?.land && { 
            "addressCountry": {
              "@type": "Country",
              "name": wpSurfvakantie.surfvakantieNieuw.land
            }
          })
        }
        : null,
      "aggregateRating": wpSurfvakantie?.surfvakantieNieuw?.rating
        ? {
          "@type": "AggregateRating",
          "ratingValue": wpSurfvakantie.surfvakantieNieuw.rating,
          "reviewCount": wpSurfvakantie.surfvakantieNieuw.numberOfReviews || "0"
        }
        : null,
      "makesOffer": wpSurfvakantie?.surfvakantieNieuw?.inleidingPrijs
        ? {
          "@type": "Offer",
          "price": wpSurfvakantie.surfvakantieNieuw.inleidingPrijs,
          "priceCurrency": "EUR",
          "availability": "https://schema.org/InStock",
          "url": currentUrl
        }
        : null,
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": currentUrl,
        "author": {
          "@type": "Person",
          "name": author.node?.firstName || null,
          "description": author.node?.description || null,
          "jobTitle": author.node?.acfUserFields?.jobTitle || null,
          "worksFor": {
            "@type": "Organization",
            "name": "SurfaWhile",
            "url": "https://www.surfawhile.com"
          },
          "image": author.node?.acfUserFields?.profileImage?.publicUrl || null,
          "sameAs": author.node?.seo?.social?.linkedin
            ? [author.node.seo.social.linkedin]
            : []
        }
      },
      "breadcrumb": {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.surfawhile.com"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Surfvakanties",
            "item": "https://www.surfawhile.com/surfvakanties"
          },
          ...(parentUri ? [{
            "@type": "ListItem",
            "position": 3,
            "name": surfvakantieNieuw?.land || "Onbekend",
            "item": `https://www.surfawhile.com${parentUri}`
          }] : []),
          {
            "@type": "ListItem",
            "position": parentUri ? 4 : 3,
            "name": wpSurfvakantie?.title || "Onbekende Surfvakantie",
            "item": currentUrl
          }
        ]
      }
    })}
</script>



</Helmet>


  <SEO 
  title={wpSurfvakantie.seo.title}
  description={wpSurfvakantie.seo.metaDesc}
  />

<div key={location.pathname}>



  
{/* START HEADER */}




    <div className="w-full border-none md:border-y-2 overflow-overflow p-2">

   

      <div className="container px-1 mx-auto w-full">

      <div className="breadcrumbs font-inter text-sm py-2">
      <Link className="text-gray-400 font-semibold" to="/"> Home</Link> &gt; 
      <Link className="text-gray-400 font-semibold" to={lang === "en" ? "/en/surf-camps" : "/surfvakanties"}>
      <span className="text-gray-400 font-semibold">{lang === "en" ? " Surf Camps" : " Surfvakanties"} </span> </Link> &gt; 
      <Link className="text-gray-400 font-semibold" to={parentUri}> {surfvakantieNieuw.land}</Link> &gt; 
      <span className="text-gray-600 font-semibold">{title} </span>
      </div>

        <h1 className="text-3xl sm:text-4xl mt-2 uppercase text-center sm:text-left">
          {title}, {surfvakantieNieuw.land}
        </h1>

        {surfvakantieNieuw?.dreamseaEarlyBird && (
          <div className="container">
            <form className="w-full md:w-1/2 ml-1 bg-orange-100 p-2 rounded-lg shadow" onSubmit={handleSubmit}>
              <h2 className="text-2xl my-2 font-semibold">Pre-registreer voor 2025</h2>
              <p className="font-inter py-2 bg-orange-100">
                De prijzen voor 2025 worden spoedig gepubliceerd. Pre-registreer je nu 
                <b> geheel gratis en vrijblijvend</b> en profiteer van <b>zeer hoge Early Bird korting</b> voor de zomer van 2025!
              </p>

              <label className="font-inter font-semibold mt-2" htmlFor="naam">Voor- en achternaam:</label>
              <input
                type="text"
                id="naam"
                value={discountNaam}
                className="rounded-lg bg-white border-none w-full"
                onChange={(event) => setNaam(event.target.value)}
              />

              <label className="font-inter font-semibold" htmlFor="emailadres">E-mailadres:</label>
              <input
                type="text"
                id="emailadres"
                value={discountEmail}
                className="block rounded-lg bg-white border-none w-full "
                onChange={(event) => setEmailadres(event.target.value)}
              />

              <input
                type="submit"
                value="Verzend"
                className="my-2 text-white bg-black rounded-lg cursor-pointer px-5 py-2 font-semibold font-inter"
              />
            </form>
          </div>
        )}
        
        


     {(surfvakantieNieuw.discount || surfvakantieNieuw.hurry) && (
      <div className="container my-5">
        <div className="bg-orange-50 font-inter text-sm p-4 my-2 rounded-lg top-0 left-0 z-10 flex flex-col space-y-3">

          {surfvakantieNieuw.discount && (
            <div className="flex items-center">
              <span className="mr-2 text-red-500">

                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M14.25 7.756a4.5 4.5 0 1 0 0 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
              </span>
              <p className="font-inter text-slate-500" dangerouslySetInnerHTML={{ __html: surfvakantieNieuw.discount }} />
            </div>
          )}


          {surfvakantieNieuw.hurry && (
            <div className="flex items-center">
              <span className="mr-2 text-orange-500">
      
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z" />
                </svg>
              </span>
              <p className="font-inter text-slate-500" dangerouslySetInnerHTML={{ __html: surfvakantieNieuw.hurry }} />
            </div>
          )}
        </div>
      </div>
    )}





    <div id="fotos" className="grid grid-cols-1 md:grid-cols-12 gap-6 mt-2 w-full mx-auto">
    
      <div className="col-span-12 md:col-span-6 lg:col-span-5">
      <div className="relative rounded-lg group overflow-hidden h-full">
      

      <img src={imageOne} 
      alt="Grote afbeelding" 
      className="rounded-lg w-full h-full object-cover" 
      loading="eager" 
    />

    {surfvakantieNieuw?.rating && (
      <div className="absolute top-2 left-2 bg-white p-3 rounded-lg shadow-lg flex items-center space-x-3 font-inter z-30">
        
        <div className={`relative flex items-center justify-center text-white font-bold text-lg w-10 h-10 rounded-full ${calculationBgColor}`}>
          {average || "N/A"}
        </div>
        <span className="text-gray-500 text-sm ml-1" style={{ marginLeft: '-2px', marginTop: '28px' }}>
          / 5
        </span>

      
        <div>
          <p className={`text-lg font-semibold ${descriptionColor}`}>
            {descriptionText}
          </p>
          <a href="#reviews" className="anchor">
          <p className="text-gray-500 text-sm">
            Score uit <span className="font-bold underline">{numberOfReviews} reviews</span>
          </p>
          </a>
        </div>
      </div>
    )}

      
          <div onClick={() => setModalOpen(true)} className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 flex justify-center items-center text-white font-bold font-inter cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity">
            
            {lang === "en" ? `Open all pictures` : `Open alle foto's`}
          </div>
        </div>
      </div>

      <div className="col-span-12 md:col-span-6 lg:col-span-4 grid grid-cols-2 gap-4">
        <div className="relative group overflow-hidden rounded-lg">
          <img
            src={imageTwo} 
            alt="Kleine afbeelding 1" 
            className="w-full h-full object-cover" 
            loading="eager" 
          />
          <div onClick={() => setModalOpen(true)} className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 flex justify-center items-center text-white font-bold font-inter cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity">
          {lang === "en" ? `Open all pictures` : `Open alle foto's`}
          </div>
        </div>

        <div className="relative group overflow-hidden rounded-lg">
          <img
            src={imageThree} 
            alt="Kleine afbeelding 2" 
            className="w-full h-full object-cover" 
            loading="eager" 
          />
          <div onClick={() => setModalOpen(true)} className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 flex justify-center items-center text-white font-bold font-inter cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity">
          {lang === "en" ? `Open all pictures` : `Open alle foto's`}
          </div>
        </div>

        <div className="relative group overflow-hidden rounded-lg">
          <img
            src={imageFour} 
            alt="Kleine afbeelding 3" 
            className="w-full h-full object-cover" 
            loading="eager" 
          />
          <div onClick={() => setModalOpen(true)} className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 flex justify-center items-center text-white font-bold font-inter cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity">
          {lang === "en" ? `Open all pictures` : `Open alle foto's`}
          </div>
        </div>

        <div className="relative group overflow-hidden rounded-lg">
          <img
            src={imageFive} 
            alt="Kleine afbeelding 4" 
            className="w-full h-full object-cover" 
            loading="eager" 
          />
          <div 
        onClick={() => setModalOpen(true)} 
        className="absolute inset-0 bg-black bg-opacity-30 group-hover:bg-opacity-50 flex justify-center items-center text-white font-bold font-inter cursor-pointer transition-opacity"
      >
        {lang === "en" ? `Open all pictures` : `Open alle foto's`}
      </div>
        </div>
      </div>


      <div className="col-span-12 lg:col-span-3 bg-stone-100 p-6 rounded-lg font-inter">
        <h3 className="text-2xl font-bold mb-4">
        
        {lang === "en" ? `Summary` : `In het kort`}
          
          </h3>
        <table className="text-sm w-full">

      
          <tr className="h-8">
            <td className="align-middle">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 inline" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path d="M12 21c-3.86-3.17-7-6.68-7-10a7 7 0 1114 0c0 3.32-3.14 6.83-7 10z" />
                <circle cx="12" cy="11" r="2.5" fill="currentColor" />
              </svg>
            </td>
            <td>{surfvakantieNieuw.inleidingLocatie}, {surfvakantieNieuw.inleidingRegio}</td>
          </tr>


      
          <tr className="h-8">
            <td className="align-middle">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 inline" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
              </svg>
            </td>
            <td className="align-middle">{surfvakantieNieuw.inleidingMinimumleeftijd}</td>
          </tr>


      
          <tr className="h-8">
            <td className="align-middle">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 inline" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </td>
            <td className="align-middle">{surfvakantieNieuw.inleidingTypenReiziger}</td>
          </tr>






          <tr className="h-8">
            <td className="align-middle">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 inline" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
              </svg>
            </td>
            <td className="align-middle">{surfvakantieNieuw.inleidingVervoer}</td>
          </tr>


          <tr className="h-8">
            <td className="align-middle">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 inline" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
              </svg>
            </td>
            <td className="align-middle">{surfvakantieNieuw.inleidingOpen}</td>
          </tr>

      
          <tr className="h-8">
            <td className="align-middle ">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2 inline">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
    </svg>

            </td>
            <td className="align-middle">{surfvakantieNieuw.extra}</td>
          </tr>


      
          <tr className="h-8">
            <td className="align-middle">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 inline" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
              </svg>
            </td>
            <td className="align-middle">{surfvakantieNieuw.inleidingSurfles}</td>
          </tr>

          
          <tr className="h-8">
            <td className="align-middle">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 inline" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
              </svg>
            </td>
            <td className="align-middle">{surfvakantieNieuw.inleidingTypenVerblijf}</td>
          </tr>

          
                <tr className="h-8">
            <td className="align-middle ">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2 inline" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />
              </svg>
            </td>
            <td className="align-middle">{surfvakantieNieuw.inleidingVoertaal}</td>
          </tr>

        </table>
      </div>
    </div>









    <div className="flex justify-center">
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        className="BlackModal"
        overlayClassName="Overlay"
      >

        <Swiper
          style={{
            "--swiper-navigation-color": "#fff",
            "--swiper-pagination-color": "#fff",
          }}
          loop={true}
          spaceBetween={10}
          navigation={true}
          thumbs={{swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null}}
          modules={[FreeMode, Navigation, Thumbs]}
          className="mySwiper2"
          autoHeight={true}
          centeredSlides={true} 
          onSlideChange={(swiper) => handleSlideChange(swiper)}
        >
          {surfvakantieNieuw.gallery2.map((foto, index) => (
            <SwiperSlide key={index} className="flex justify-center items-center h-full">
              <span className="text-white font-inter">{index + 1} / </span>
              <span className="text-white font-inter">{totalSlides}</span>
              <img src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(foto.publicUrl)}&format=webp&w=600&h=400&fit=crop`}
      className="rounded-lg max-h-[700px]" alt="alt"  />
            </SwiperSlide>
          ))}
        </Swiper>



      
        <button className="inline font-sans text-sm bg-black text-white rounded-xl px-5 py-2 mt-2 mr-2 font-bold" onClick={() => setModalOpen(false)}>
          {lang === "en" ? `Close` : ` Sluit`}
          </button>
      </Modal>
    </div>  



</div>
</div>



<div className="container px-2 mx-auto sticky top-1 z-30">
  <nav className="hidden md:flex bg-stone-100 py-4 mt-5 rounded-full shadow-md justify-between items-center">

    <div>
      <ul className="font-inter flex justify-start space-x-6">
        <li className="list-none">
          <a href="#fotos" className="font-semibold text-sm anchor">
            {lang === "en" ? `Gallery` : `Foto's`}
          </a>
        </li>
        <li className="list-none">
          <a href="#inleiding" className="font-semibold text-sm anchor">
          {lang === "en" ? `Overview` : `Overzicht`}
          </a>
        </li>
        <li className="list-none">
          <a href="#locatie" className="font-semibold text-sm anchor">
            {lang === "en" ? `Location & Transport` : `Locatie & Vervoer`}
          </a>
        </li>
        <li className="list-none">
          <a href="#accommodatie" className="font-semibold text-sm anchor">
            {lang === "en" ? `Accommodation` : `Accommodatie`}
          </a>
        </li>
        <li className="list-none">
          <a href="#surfen" className="font-semibold text-sm anchor">
            {lang === "en" ? `Surfing` : `Surfen`}
          </a>
        </li>
        <li className="list-none">
          <a href="#packages" className="font-semibold text-sm anchor">
          {lang === "en" ? `Prices & Book` : `Prijzen & Boeken`}
          </a>
        </li>
        <li className="list-none">
          <a href="#praktisch" className="font-semibold text-sm anchor">
            FAQ
          </a>
        </li>
        {rating !== null && !isNaN(rating) && numberOfReviews !== null && !isNaN(numberOfReviews) && (
          <li className="list-none">
            <a href="#reviews" className="font-semibold text-sm anchor">
              Reviews
            </a>
          </li>
        )}
      </ul>
    </div>


   
    <div className="flex items-center space-x-4">
      <div className="font-inter font-semibold text-slate-500 text-sm lg:text-sm whitespace-nowrap">
        <b>
          {lang === "en" ? `From €` : `v.a. €`}
          {surfvakantieNieuw.inleidingPrijs}</b>
      </div>
      <a href={surfvakantieNieuw.blUrl}>
        <button className="bg-orange-500 text-white font-semibold font-inter py-1.5 px-3 sm:py-2 sm:px-6 rounded-full hover:bg-amber-600 flex items-center mr-5">
        {lang === "en" ? `Start booking` : `Start boeking`}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6 mx-1"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
          </svg>
        </button>
      </a>
    </div>
  </nav>
</div>




<div id="inleiding" className="container mx-auto p-2">


{average !== null && !isNaN(average) && numberOfReviews !== null && !isNaN(numberOfReviews) && (
  <div className="flex w-full justify-center">
    <div className="font-inter inline md:hidden my-5">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 inline-flex -mt-1" style={{ color: 'gold' }}>
        <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clipRule="evenodd" />
      </svg> {average} / 5 - {numberOfReviews} <span className="underline">reviews</span>
    </div>
  </div>
)}

<div className="grid grid-cols-1 md:grid-cols-3 my-5">
  <div className="col-start-1 md:col-end-3 p-2">

  <div className="my-5">
  <h2 className="text-2xl sm:text-3xl mt-5 text-center sm:text-left">
  {lang === "en" ? `About ${title}` : `Over ${title}`}
</h2>

    <p className="mt-2 font-inter text-gray-500 font-medium">{surfvakantieNieuw.introduction}</p>

</div>




<div className="my-5 p-5 bg-sky-200 rounded-lg flex flex-col sm:flex-row items-center">
<span onClick={setTravelSpecialistModalOpen}>
  <div className="flex-shrink-0 w-72 hover:bg-sky-300 cursor-pointer flex flex-col items-center p-5 justify-between h-full">
        
        

{author.node.firstName === 'Hans' ? (
  <img 
    className="w-60 h-60 mb-2 rounded-full object-cover"
    src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(pictureHans)}&format=webp&w=600&h=400&fit=crop&q=90`}
    alt="Hans' afbeelding"
    width={60} 
    height={60}
  />
) : author.node.firstName === 'Mees' && (
  <img 
    className="w-60 h-60 mb-2 rounded-full object-cover"
    src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(pictureMees)}&format=webp&w=600&h=400&fit=crop&q=90`}
    alt="Mees' afbeelding"
    width={60} 
    height={60} 
  />
)}


    <h4 className="uppercase text-xl">{author.node.firstName}</h4>
    <span className="text-sm font-semibold font-inter text-slate-500">{author.node.jobTitle.jobTitle}</span>
  
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 inline">
  <path fillRule="evenodd" d="M16.72 7.72a.75.75 0 011.06 0l3.75 3.75a.75.75 0 010 1.06l-3.75 3.75a.75.75 0 11-1.06-1.06l2.47-2.47H3a.75.75 0 010-1.5h16.19l-2.47-2.47a.75.75 0 010-1.06z" clipRule="evenodd" />
</svg>

  </div>
  </span>

  <div className="flex-grow p-5 flex flex-col justify-between"> 
  <div>
    <h2 className="text-2xl sm:text-3xl my-2 uppercase text-center sm:text-left">
      {lang === "en" ? `Vision from  Surf Travel Expert ${author.node.firstName}` : ` Visie Van Surf Travel Expert ${author.node.firstName}`}
    </h2>
   <blockquote className="text-base md:text-lg italic text-gray-700 border-0 -ml-5">
      <p className="font-inter" dangerouslySetInnerHTML={{ __html: surfvakantieNieuw.ourVision }} />
    </blockquote>
  </div>
  <div className="flex flex-col sm:flex-row justify-between items-center w-full"> 
    <p className="font-inter font-semibold border-t-2 border-slate-500 mt-4 sm:mt-0">
      {lang === "en" ? `Objective advice from ${author.node.firstName}?` : `Gratis & persoonlijk advies van ${author.node.firstName}?`}
    </p> 
    <a href="https://calendly.com/info-01kd/15min" className="w-full sm:w-auto mt-5 sm:mt-0">
      <button className="bg-blue-500 text-white mt-5 font-semibold font-inter px-4 py-2 rounded-xl hover:bg-blue-600 w-full sm:w-auto block">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 inline mx-2">
          <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
        </svg>
        
        {lang === "en" ? `Free Online Meeting` : `Gratis bel-afspraak`}

      </button> 
    </a>
    <span><a href={author.node.seo.social.linkedIn}>
    <img 
    src="https://wp.surfawhile.com/wp-content/uploads/2025/01/linkedin.svg" 
    alt="LinkedIn logo" />
    </a>
    
    </span>
  </div>
</div>
</div>


<Modal
        isOpen={travelSpecialistModalOpen}
        onRequestClose={() => setTravelSpecialistModalOpen(false)}

        className="w-1/4 right-0 top-0 h-full fixed bg-white shadow-lg z-99"
        overlayClassName="z-40 fixed inset-0 bg-black bg-opacity-50"
      >
  <button className="block font-sans text-sm bg-black text-white rounded-xl px-5 py-2 m-2 font-semibold" onClick={() => setTravelSpecialistModalOpen(false)}>
    {lang === "en" ? `Close` : `Sluit`}
    </button>

<div className="p-5 font-inter">


 {author.node.firstName === 'Hans' && (
       <img 
       className="w-60 h-60 mb-2 rounded-full" 
       src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(pictureHans)}&format=webp&w=600&h=400&fit=crop&q=90`}
       alt="Hans' afbeelding"
       width={60} 
       height={60} 
  />
      )}
      {author.node.firstName === 'Mees' && (
      <img 
      className="w-60 h-60 mb-2 rounded-full" 
      src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(pictureMees)}&format=webp&w=600&h=400&fit=crop&q=90`}
      alt="Mees' afbeelding"
      width={60} 
      height={60} 
    />      
)}


<h2 className="font-oswald uppercase">TRAVEL SPECIALIST {author.node.firstName}</h2>

<p>{author.node.description}</p>
  
<a href="https://calendly.com/info-01kd/15min">
<button className="bg-blue-500 text-white font-semibold font-inter px-4 py-2 rounded-xl hover:bg-blue-600"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 inline mx-2">
  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
</svg>
 {lang === "en" ? `Free Online Meeting` : `Gratis bel-afspraak`}
 </button> 
</a>


</div>
</Modal>






  
  <div className="bg-stone-100 rounded-xl p-5 my-5">
  <h2 className="text-2xl sm:text-3xl my-2 text-center sm:text-left mt-5">
    {lang === "en" ? `${title} summary` : `${title} in het kort`}
    </h2>

  <div className="grid grid-cols-1 md:grid-col-2 lg:grid-cols-2 ">
  
  <div className="font-inter text-sm">
  
  <p className="mb-1 uppercase font-light text-sm">
    {lang === "en" ? `Location` : `Locatie`}
  </p>

  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2 inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
</svg>
{surfvakantieNieuw.inleidingLocatie}, {surfvakantieNieuw.inleidingRegio}
  </div>

  <div className="font-inter text-sm">
  <p className="mb-1 uppercase font-light text-sm">
    {lang === "en" ? `Transport` : `Vervoer`}
  </p>

  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2 inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
</svg>
{surfvakantieNieuw.inleidingVervoer}
    </div>

    <div className="font-inter text-sm">
  <p class="mt-2 mb-1 uppercase font-light text-sm">

    {lang === "en" ? `Available` : `Beschikbaar`}
  
  </p>

  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2 inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
</svg>
 {surfvakantieNieuw.inleidingOpen}
    </div>

    <div className="font-inter text-sm">
  <p className="mt-2 mb-1 uppercase font-light text-sm">
    {lang === "en" ? `Accommodation` : `Typen verblijf`}
    </p>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2 inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
</svg>
 {surfvakantieNieuw.inleidingTypenVerblijf}
    </div>
    

    </div>

    <div className="my-2 border-b-2 border-grey-500"></div>
    <h2 className="text-2xl sm:text-3xl my-2 text-center sm:text-left mt-5">
      {lang === "en" ? `For whom?` : `Voor wie?`}
    </h2>

  <div className="grid grid-cols-1 md:grid-col-2 lg:grid-cols-2">
  
  <div className="font-inter text-sm">
  <p className="mb-1 uppercase font-light text-sm">
    {lang === "en" ? `Minimum age` : `Mimimumleeftijd`}
  </p>

  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2 inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
</svg>
{surfvakantieNieuw.inleidingMinimumleeftijd}
    </div>
  
  <div className="font-inter text-sm">
  <p className="mb-1 uppercase font-light text-sm">
    {lang === "en" ? `Types of Traveller` : `Typen reizigers`}
  </p>

  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2 inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
</svg>
 {surfvakantieNieuw.inleidingTypenReiziger}
    </div>

    <div className="font-inter text-sm">
    <p className="mt-2 mb-1 uppercase font-light text-sm">
      {lang === "en" ? `Language` : `Voertaal`}
    </p>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2 inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />
</svg>
 {surfvakantieNieuw.inleidingVoertaal}
    </div>
  
  <div className="font-inter text-sm">
  <p className="mt-2 mb-1 uppercase font-light text-sm">
    {lang === "en" ? `Surf Course` : `Surfles`}
    </p>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mr-2 inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
</svg>
 {surfvakantieNieuw.inleidingSurfles}
  </div>
  </div>
   </div> 

  
   {surfvakantieNieuw.video && (
  <div className="container p-2 my-3 mx-auto">
    <div className="w-full">
      <iframe 
        width="100%" 
        height="400" 
        src={surfvakantieNieuw.video} 
        className="rounded" 
        title="YouTube video player" 
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen>
      </iframe>
    </div>
  </div>
)} 

<p className="mt-2 font-inter text-slate-500" dangerouslySetInnerHTML={{ __html:surfvakantieNieuw.languageSchool}}/>






{/* START HIGHLIGHTS */}

<div className="bg-stone-200 bg-opacity-50 p-5 rounded-xl my-5">
<h3 className="text-2xl sm:text-3xl my-2 uppercase text-center sm:text-left mt-5">
  {lang === "en" ? `Highlights` : `Hoogtepunten`}
</h3>
        {surfvakantieNieuw.hoogtepunten.map(hoogtepunt => (
         
          <div>
          <h4 className="mt-5 font-inter text-lg font-semibold" dangerouslySetInnerHTML={{ __html:hoogtepunt.hoogtepuntHeader1}}/>
          
          <p className="font-inter text-gray-500">

{hoogtepunt.hoogtepuntBody1}</p>

<h4 className="mt-5 font-inter text-lg font-semibold" dangerouslySetInnerHTML={{ __html:hoogtepunt.hoogtepuntHeader2}}/>
          <p className="font-inter text-gray-500">
            {hoogtepunt.hoogtepuntBody2}</p>

            <h4 className="mt-5 font-inter text-lg font-semibold" dangerouslySetInnerHTML={{ __html:hoogtepunt.hoogtepuntHeader3}}/>
          <p className="font-inter text-gray-500">

          {hoogtepunt.hoogtepuntBody3}</p>
          </div>
      ))}

</div>

{/* EINDE HIGHLIGHTS */}






<div id="locatie" className="mt-5 mb-1 p-2">
<h2 className="text-2xl sm:text-3xl my-2 text-center sm:text-left mt-5">{surfvakantieNieuw.inleidingLocatie}, {surfvakantieNieuw.land} </h2>
<p className="mt-2 font-inter text-slate-500">{surfvakantieNieuw.destination}</p>
</div>


<div className="container p-2">

{surfvakantieNieuw.vervoer && (
  <div>
    <h3 className="text-2xl font-semibold mb-4">
      {lang === "en" ? `Transport` : `Vervoer`}
      </h3>
    <p
      className="mt-2 font-inter text-slate-500"
      dangerouslySetInnerHTML={{ __html: surfvakantieNieuw.vervoer }}
    />
  </div>
)}


  <h3 className="text-2xl mt-5 mb-4">
    {lang === "en" ? `Location op map` : `Locatie op kaart`}
  </h3>
  
  <div className="relative" style={{ paddingBottom: "56.25%", height: 0 }}>
    <iframe
      src={surfvakantieNieuw.mapsUrl}
      title="Kaart weergave"
      className="absolute top-0 left-0 w-full h-full rounded-lg shadow-md"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  </div>
</div>



{/* Taalschool */}


{type == "Surf + Taalreis" && (

<div className="my-5 p-5">
<h2 className="text-2xl sm:text-3xl my-2 uppercase text-center sm:text-left mt-5">Over de Taallessen</h2>
<p className="mt-2 font-inter text-slate-500" dangerouslySetInnerHTML={{ __html:surfvakantieNieuw.languageSchool}}/>
</div>

)}

<div id="accommodatie" className="container p-2">

<h2 className="text-2xl sm:text-3xl my-2 uppercase text-center sm:text-left mt-5">
  {lang === "en" ? `Where you will stay` : ` Waar je verblijft`}
</h2>

<p className="font-inter text-slate-500" dangerouslySetInnerHTML={{ __html: surfvakantieNieuw.accommodatieInleiding }} />

<div className="w-full flex justify-end">
   
   <button className="border-2 font-sans rounded-full accommodaties-prev bg-white">
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
   <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
    </svg>
   </button>
   
   <button className="border-2 font-sans rounded-xl accommodaties-next bg-white">
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
   <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
 </svg>
 
   </button>
 
   </div>


   <Swiper
    onClick={setAccommodationModalOpen}
    modules={[Navigation]}
    spaceBetween={10}
    breakpoints={{
      640: {
        slidesPerView: 2,
      },
    }}
    className="my-5 font-sans cursor-pointer"
    navigation={{
      nextEl: ".accommodaties-next",
      prevEl: ".accommodaties-prev"
    }}
>
   
   <div>
    
    {surfvakantieNieuw.accommodaties.map(accommodatie => (
  
  <SwiperSlide>
  <div className="card bg-stone-200 bg-opacity-50 rounded-xl p-2">


  <img 
  src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(accommodatie.foto.publicUrl)}&format=webp&w=600&h=400&fit=crop`} 
  className="rounded-lg z-5" 
  alt="alt" 
/>


<div className="px-4 py-3 w-72">
    <span className="text-gray-400 mr-3 uppercase text-xs">{accommodatie.typering}</span>
    <p className="text-lg font-bold text-black truncate block capitalize">{accommodatie.naam}</p>
    <div className="flex items-right">
        <p className="text-gray-500 font-sans">{accommodatie.vanafprijs}</p>
        </div>
    </div>



</div>


</SwiperSlide>
        
))}

</div>


</Swiper>

</div>

      <Modal
        isOpen={accommodationModalOpen}
        onRequestClose={() => setAccommodationModalOpen(false)}
        className="Modal"
        overlayClassName="Overlay"
      >
<div className="p-5">

<Tab.Group>
<Tab.List className="w-full">
{surfvakantieNieuw.accommodaties.map((accommodatie, index) => (
    <Tab
    key={accommodatie.naam}
    className={`inline font-sans text-sm bg-black text-white rounded-xl px-5 py-2 mr-2 border-2 font-sans rounded-full ${activeTab === index ? 'bg-black' : 'bg-gray-300'}`}
    onClick={() => handleClick(index)}
  >
    {accommodatie.naam}
  </Tab>
))}
</Tab.List>
<Tab.Panels>
{surfvakantieNieuw.accommodaties.map(accommodatie => (
  <div>
  <Tab.Panel>

  <div className="w-full flex justify-end">
   
   <button className="border-2 font-sans rounded-full accommodaties-gallery-prev bg-white">
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
   <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
    </svg>
   </button>
   
   <button className="border-2 font-sans rounded-xl accommodaties-gallery-next bg-white">
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
   <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
 </svg>
 
   </button>
   </div>

   <Swiper
   id=""
   modules={[Navigation]}
   spaceBetween={10}
   slidesPerView={1}
   breakpoints={{
    640: {
      slidesPerView: 2,
    },
  }}
   className="my-5 font-sans "
   navigation={{
     nextEl: ".accommodaties-gallery-next",
     prevEl: ".accommodaties-gallery-prev"
   }}
>
  {accommodatie.gallery.map(foto => (
  
  <SwiperSlide>
  <img 
  src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(foto.publicUrl)}&format=webp&w=600&h=400&fit=crop`} 
  className="rounded-lg z-5" 
  alt="alt" 
/>
  </SwiperSlide>
  ))}

</Swiper>
<h3 className="font-oswald text-2xl">{accommodatie.naam}</h3>
<p className="font-sans" dangerouslySetInnerHTML={{ __html: accommodatie.beschrijving }} />
</Tab.Panel> 
  
</div>
))}
</Tab.Panels>
</Tab.Group>


<button className="inline font-sans text-sm bg-black text-white rounded-xl px-5 py-2 mt-2 mr-2" onClick={() => setAccommodationModalOpen(false)}>
  {lang === "en" ? `Close` : ` Sluit`}
</button>

</div>
</Modal>
<div>
</div>











<div id="surfen" className="container p-2">

<h2 className="text-2xl sm:text-3xl my-2 uppercase text-center sm:text-left mt-5">
  {lang === "en" ? `Surfing` : ` Surfen`}
</h2>

<p className="font-inter text-slate-500" dangerouslySetInnerHTML={{ __html: surfvakantieNieuw.surfenInleiding }} />

<div className="w-full flex justify-end">
   
   <button className="border-2 font-sans rounded-full surfen-prev bg-white">
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
   <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
    </svg>
   </button>
   
   <button className="border-2 font-sans rounded-xl surfen-next bg-white">
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
   <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
 </svg>
 
   </button>
 
   </div>


   <Swiper
    onClick={setSurfingModalOpen}
    modules={[Navigation]}
    spaceBetween={10}
    slidesPerView={1}
    breakpoints={{
     640: {
       slidesPerView: 2,
     },
   }}
    className="my-5 font-sans cursor-pointer"
    navigation={{
      nextEl: ".surfen-next",
      prevEl: ".surfen-prev"
    }}
>
   
   <div>
    
    {surfvakantieNieuw.surfen.map(surf => (
  
  <SwiperSlide>
  <div className="card bg-stone-200 bg-opacity-50 rounded-xl p-2">

<img 
  src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(surf.foto.publicUrl)}&format=webp&w=600&h=400&fit=crop`} 
  className="rounded-lg z-5" 
  alt="alt" 
/>

<div className="px-4 py-3 w-72">
    <span className="text-gray-400 mr-3 uppercase text-xs">{surf.typering}</span>
    <p className="text-lg font-bold text-black truncate block capitalize">{surf.naam}</p>
    <div className="flex items-right">
        <p className="text-gray-500 font-sans">{surf.vanafprijs}</p>
        </div>
    </div>

</div>

</SwiperSlide>
        
))}

</div>


</Swiper>

</div>

      <Modal
        isOpen={surfingModalOpen}
        onRequestClose={() => setSurfingModalOpen(false)}
  
        className="Modal"
        overlayClassName="Overlay"
      >
<div className="p-5">
<Tab.Group>
<Tab.List className="w-full">
{surfvakantieNieuw.surfen.map((surfen, index) => (
    <Tab
    key={surfen.naam}
    className={`inline font-sans text-sm bg-black text-white rounded-xl px-5 py-2 mr-2 border-2 font-sans rounded-full ${activeSurfTab === index ? 'bg-black' : 'bg-gray-300'}`}
    onClick={() => handleSurfClick(index)}
  >
    {surfen.naam}
  </Tab>
))}

</Tab.List>
<Tab.Panels>
{surfvakantieNieuw.surfen.map(surf => (
  <div>

  <Tab.Panel>
  <img 
  src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(surf.foto.publicUrl)}&format=webp&w=600&h=400&fit=crop`} 
  className="rounded-lg z-5 my-2" 
  alt="alt" 
  />

  <h3 className="font-oswald">{surf.naam}</h3>
  <p className="font-sans">{surf.beschrijving}</p>
  </Tab.Panel>
    
    </div>
    ))}
  </Tab.Panels> 
  </Tab.Group>
  <button className="inline font-sans text-sm bg-black text-white rounded-xl px-5 py-2 mt-2 mr-2" onClick={() => setSurfingModalOpen(false)}>
    {lang === "en" ? `Close` : ` Sluit`}
    </button>
  </div>
  </Modal>
  {/*EINDE SURFEN */}




{/* START ACTIVITEITEN */}

<div className="container p-2">

<h2 className="text-2xl sm:text-3xl my-2 uppercase text-center sm:text-left mt-5">
  {lang === "en" ? `Other activities` : `Overige activiteiten`}
</h2>
<p className="font-inter text-slate-500" dangerouslySetInnerHTML={{ __html: surfvakantieNieuw.activiteitenInleiding }} />
<div className="w-full flex justify-end">
   
   <button className="border-2 font-sans rounded-full activiteiten-prev bg-white">
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
   <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
    </svg>
   </button>
   
   <button className="border-2 font-sans rounded-xl activiteiten-next bg-white">
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
   <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
 </svg>
 
   </button>
 
   </div>


   <Swiper
    onClick={setActivitiesModalOpen}
    modules={[Navigation]}
    spaceBetween={10}
    slidesPerView={1}
    breakpoints={{
     640: {
       slidesPerView: 2,
     },
   }}
    className="my-5 font-sans cursor-pointer"
    navigation={{
      nextEl: ".activiteiten-next",
      prevEl: ".activiteiten-prev"
    }}
>
   
   <div>
    
    {surfvakantieNieuw.activities.map(activity => (
  
  <SwiperSlide>
  <div className="card bg-stone-200 bg-opacity-50 rounded-xl p-2">

  <img 
  src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(activity.foto.publicUrl)}&format=webp&w=600&h=400&fit=crop`} 
  className="rounded-lg z-5" 
  alt="alt" 
  />

<div className="px-4 py-3 w-72">
    <span className="text-gray-400 mr-3 uppercase text-xs">{activity.typering}</span>
    <p className="text-lg font-bold text-black truncate block capitalize">{activity.naam}</p>
    <div className="flex items-right">
        <p className="text-gray-500 font-sans">{activity.vanafprijs}</p>
        </div>
    </div>


</div>


</SwiperSlide>
        
))}

</div>


</Swiper>

</div>

      <Modal
        isOpen={activitiesModalOpen}
        onRequestClose={() => setActivitiesModalOpen(false)}
        className="Modal"
        overlayClassName="Overlay"
      >

<div className="p-5">
<Tab.Group>
<Tab.List className="w-full">
{surfvakantieNieuw.activities.map((activity, index) => (
    <Tab
    key={activity.naam}
    className={`inline font-sans text-sm bg-black text-white rounded-xl px-5 py-2 mr-2 border-2 font-sans rounded-full ${activeActivityTab === index ? 'bg-black' : 'bg-gray-300'}`}
    onClick={() => handleActivityClick(index)}
  >
    {activity.naam}
  </Tab>
))}
</Tab.List>
<Tab.Panels>
{surfvakantieNieuw.activities.map(activity => (
  <div>

  <Tab.Panel>
  <img src={activity.foto.publicUrl}  className="rounded-lg my-2" alt="alt" />
  <h3 className="font-oswald">{activity.naam}</h3>
  <p className="font-inter">{activity.beschrijving}</p>
  </Tab.Panel>
    
    </div>
    ))}
  </Tab.Panels> 
  </Tab.Group>
  <button className="inline font-sans text-sm bg-black text-white rounded-xl px-5 py-2 mt-2 mr-2" onClick={() => setActivitiesModalOpen(false)}>
      {lang === "en" ? `Close` : ` Sluit`}
  </button>
</div>
  </Modal>
{/*  EINDE ACTIVITEITEN */}




{/* START MAALTIJDEN */}
<div className="container p-5">

<h2 className="text-2xl sm:text-3xl my-2 uppercase text-center sm:text-left mt-5">
  {lang === "en" ? `Meals` : `Maaltijden`}
</h2>
<p className="font-inter text-slate-500" dangerouslySetInnerHTML={{ __html: surfvakantieNieuw.maaltijdenInleiding }} />
<div className="w-full flex justify-end">
   
   <button className="border-2 font-sans rounded-full maaltijden-prev bg-white">
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
   <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
    </svg>
   </button>
   
   <button className="border-2 font-sans rounded-xl maaltijden-next bg-white">
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
   <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
 </svg>
 
   </button>
 
   </div>


   <Swiper
    onClick={setMaaltijdenModalOpen}
    modules={[Navigation]}
    spaceBetween={10}
    slidesPerView={1}
    breakpoints={{
     640: {
       slidesPerView: 2,
     },
   }}
    className="my-5 font-sans cursor-pointer"
    navigation={{
      nextEl: ".maaltijden-next",
      prevEl: ".maaltijden-prev"
    }}
>
   
   <div>
    
    {surfvakantieNieuw.maaltijden.map(maaltijd => (
  
  <SwiperSlide>
  <div className="card bg-stone-200 bg-opacity-50 rounded-xl p-2">


<img src={maaltijd.foto.publicUrl}  className="rounded-lg" alt="alt" />

<div className="px-4 py-3 w-72">
    <span className="text-gray-400 mr-3 uppercase text-xs">{maaltijd.typering}</span>
    <p className="text-lg font-bold text-black truncate block capitalize">{maaltijd.naam}</p>
    <div className="flex items-right">
        <p className="text-gray-500 font-sans">{maaltijd.vanafprijs}</p>
        </div>
    </div>


</div>


</SwiperSlide>
        
))}

</div>


</Swiper>

</div>

      <Modal
        isOpen={maaltijdenModalOpen}
        onRequestClose={() => setMaaltijdenModalOpen(false)}
   
        className="Modal"
        overlayClassName="Overlay"
      >
<div className="p-5">
<Tab.Group>
<Tab.List className="w-full">
{surfvakantieNieuw.maaltijden.map((meal, index) => (
    <Tab
    key={meal.naam}
    className={`inline font-inter text-sm bg-black text-white rounded-xl px-5 py-2 mr-2 border-2 font-sans rounded-full ${activeMealTab === index ? 'bg-black' : 'bg-gray-300'}`}
    onClick={() => handleMealClick(index)}
  >
    {meal.naam}
  </Tab>
))}
</Tab.List>
<Tab.Panels>
{surfvakantieNieuw.maaltijden.map(maaltijd => (
  <div>

  <Tab.Panel>
  <img src={maaltijd.foto.publicUrl}  className="rounded-lg my-2" alt="alt" />
  <h3 className="font-oswald font-bold">{maaltijd.naam}</h3>
  <p className="font-inter" dangerouslySetInnerHTML={{ __html: maaltijd.beschrijving }} />

  </Tab.Panel>
    
    </div>
    ))}
  </Tab.Panels> 
  </Tab.Group>
  <button className="inline font-sans text-sm bg-black text-white rounded-xl px-5 py-2 mt-2 mr-2" onClick={() => setMaaltijdenModalOpen(false)}>
    {lang === "en" ? `Close` : ` Sluit`}
  </button>
  </div>
  </Modal>
  {/* EINDE MAALTIJDEN */}



 


  {surfvakantieNieuw.packages?.length > 0 && (
  <div id="packages" className="container p-4">
    <h3 className="text-2xl sm:text-3xl uppercase text-gray-800">
      {lang === "en" ? `Packages` : `Pakketten`}
    </h3>

    <p className="font-inter text-slate-500 mt-1">
      {lang === "en"
        ? `Click on the desired package below for prices and availability.`
        : `Klik op het gewenste pakket hieronder voor prijzen en beschikbaarheid.`}
    </p>

    <p className="font-inter mt-1 text-slate-500 p-4 bg-green-100 rounded-lg my-2 border-2 border-green-100">
      <b>{lang === "en" ? `Always included` : `Altijd gratis inbegrepen:`}</b>
      <ul className="list-none ml-4 mt-2 space-y-1">
        <li>✔ {lang === "en" ? `Our e-book worth € 9,99` : `Ons e-book t.w.v. € 9,99`}</li>
        <li>✔ {lang === "en" ? `€ 15,- shop credit` : `€ 15,- shoptegoed`}</li>
        <li>✔ {lang === "en" ? `Objective advice from our Surf & Travel Experts` : `Objectief advies van onze Surf & Travel Experts`}</li>
      </ul>
    </p>

    <div className="grid grid-cols-1 gap-4">
      {surfvakantieNieuw.packages.map((pkg) => (
        <a href={pkg.packageBlUrl} className="block">
        <details open key={pkg.packageTitle} className="mt-1 bg-stone-100 rounded-lg shadow-md border border-stone-200">
          <summary className="px-6 py-4 font-bold text-2xl cursor-pointer flex justify-between items-center font-oswald uppercase">
            {pkg.packageTitle}
          </summary>

          <div className="px-6 pb-6 space-y-4">
            <p className="font-inter text-slate-500" dangerouslySetInnerHTML={{ __html: pkg.packageIntroduction }} />

            <div>
              <h4 className="font-semibold mb-2 uppercase">{lang === "en" ? `Included:` : `Inclusief:`}</h4>
              <ul className="list-disc list-inside font-inter text-slate-500">
  {pkg.packageBody
    .split("\n")
    .filter(item => item.startsWith("<li>") && item.endsWith("</li>"))
    .map((item, idx) => (
      <li key={idx}>{removeHtmlTags(item)}</li>
    ))}
</ul>

            </div>

            <div>
              <h4 className="font-semibold mt-4 mb-2 uppercase">{lang === "en" ? `Optional:` : `Optioneel:`}</h4>
              <ul className="list-disc list-inside font-inter text-slate-500 mt-4">
  {pkg.packageOptional
    .split("\n")
    .filter(item => item.startsWith("<li>") && item.endsWith("</li>"))
    .map((item, idx) => (
      <li key={idx}>{removeHtmlTags(item)}</li>
    ))}
</ul>
            </div>

            <p className="font-inter text-slate-500" dangerouslySetInnerHTML={{ __html: pkg.packageFooter }} />

            <div className="mt-4">
              {pkg.discountPrice ? (
                <div className="font-inter font-bold">
                  <span className="line-through block">{pkg.packageFromPrice}</span>
                  <span className="text-red-500">{pkg.discountPrice}</span>
                </div>
              ) : (
                <div className="font-inter font-bold">{pkg.packageFromPrice}</div>
              )}
            </div>

            <div className="mt-6 text-right">
              <a href={pkg.packageBlUrl} className="inline-block bg-orange-500 text-white font-semibold py-2 px-6 rounded-full font-inter">
                {lang === "en" ? `All Dates & Prices` : `Alle Prijzen & Data`}
              </a>
              <p className="text-sm text-slate-500 mt-2 font-inter">{lang === "en" ? `No costs will be charged yet` : `Er worden nog geen kosten in rekening gebracht`}</p>
            </div>
          </div>
        </details>
        </a>
      ))}
    </div>
  </div>
)}



{surfvakantieNieuw.boekingsproces && surfvakantieNieuw.boekingsproces.length > 0 && (
  <div className="container p-4 mx-auto">
  <div className="font-inter mt-4 text-slate-500 p-4 bg-stone-100 rounded-lg my-2">
    <h3 className="text-2xl mb-4">
      {lang === "en" ? `Reserve & Book` : `Reserveren & Boeken`}
    </h3>
    <table className="table-auto w-full text-left">
      <tbody>
        {surfvakantieNieuw.boekingsproces.map((item, index) => (
          <>
    
            {item.reserveren && (
              <tr className="align-top" key={`reserveren-${index}`}>
                <td className="pr-4 w-8">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 text-green-500"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                    />
                  </svg>
                </td>
                <td>
                  <b>
                    {lang === "en" ? `Reserve:` : `Reserveren:`}
                    </b>
                  {item.reserveren}
                </td>
              </tr>
            )}


            {item.betaaltermijnen && (
              <tr className="align-top" key={`betaaltermijnen-${index}`}>
                <td className="pr-4 w-8">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 text-green-500"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M14.25 7.756a4.5 4.5 0 1 0 0 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                </td>
                <td>
                  <b>
                    {lang === "en" ? `Payment terms` : `Betaaltermijnen: `}
                    </b>
                  {item.betaaltermijnen}
                </td>
              </tr>
            )}

   
            {item.betaalmethoden && (
              <tr className="align-top" key={`betaalmethoden-${index}`}>
                <td className="pr-4 w-8">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 text-green-500"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
                    />
                  </svg>
                </td>
                <td>
                  <b> 
                  {lang === "en" ? `Payment methods:` : `Betaalmethoden: `}
                  </b>
                  {item.betaalmethoden}
                </td>
              </tr>
            )}
          </>
        ))}
      </tbody>
    </table>
  </div>
  </div>
)}



{/* START PRIJSLIJSTEN */}
<div id="prijzen" className="container p-2 rounded">

<div className="bg-sky-200 px-5 py-2 rounded-xl">
<h3 className="text-2xl sm:text-3xl my-2 uppercase text-center sm:text-left mt-5">
  {lang === "en" ? `Price list` : `Prijslijst `}
  </h3>

<p className="font-inter text-slate-500" dangerouslySetInnerHTML={{ __html: surfvakantieNieuw.prijslijstInleiding }} />
</div>


<div className="overflow-x-auto">
<table className="border-collapse table-auto w-full text-sm font-inter mt-5">
  <thead>
    <tr>
      <th className="font-bold text-left p-2 font-bold text-left border-y-2 border-slate-300 p-2">{surfvakantieNieuw.prijslijstHeader1}</th>
      <th className="font-bold text-left p-2 font-bold text-left border-y-2 border-slate-300 p-2">{surfvakantieNieuw.prijslijstHeader2}</th>
      <th className="font-bold text-left p-2 font-bold text-left border-y-2 border-slate-300 p-2">{surfvakantieNieuw.prijslijstHeader3}</th>
      <th className="font-bold text-left p-2 font-bold text-left border-y-2 border-slate-300 p-2">{surfvakantieNieuw.prijslijstHeader4}</th>
    </tr>
  </thead>
  <tbody>
{surfvakantieNieuw.prijslijsten.map(prijzen => (
  
    <tr className="odd:bg-white even:bg-stone-50 p-2">
      <td className="p-2">{prijzen.startdatum}</td>
      <td className="p-2">{prijzen.gedeeld}</td>
      <td className="p-2">{prijzen.prijsPrive1p}</td>
      <td className="p-2">{prijzen.prijsPrive2p}</td>
    </tr>
   
))}
 </tbody>
 </table>
 </div>

 <h3 className="text-2xl sm:text-3xl my-2 uppercase text-center sm:text-left mt-5">Add-ons</h3>

 <p className="font-inter text-slate-500" dangerouslySetInnerHTML={{ __html: surfvakantieNieuw.addonsInleiding }} />
<table className="mt-2 font-inter table-auto text-sm">
  <thead>
    <tr>
      <th className="font-bold text-left border-y-2 border-slate-300 p-2">Item</th>
      <th className="font-bold text-left border-y-2 border-slate-300 p-2">
        {lang === "en" ? `Price:` : ` Prijs: `}
      </th>
 </tr>
  </thead>
  <tbody>
{surfvakantieNieuw.addons.map(addon  => (

    <tr className="odd:bg-white even:bg-stone-50 p-2">
      <td className="p-2">{addon.item}</td>
      <td className="p-2">{addon.prijs}</td>
    </tr>
))}
   </tbody>
 </table>

</div>
{/* EIND PRIJSLIJSTEN */}




{/* START PRAKTISCH */}
<div id="praktisch" className="container p-2">
<h3 className="text-2xl sm:text-3xl my-2 uppercase text-left sm:text-left mt-5">
  {lang === "en" ? `Practical information` : `Praktische informatie`}
</h3>
      
{surfvakantieNieuw.praktisch.map(item => (
 
 <div>
  <div className="grid grid-cols-1 gap-4">
        
        <Disclosure as="div" className="mt-1">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex justify-between w-full font-inter font-bold bg-stone-200 bg-opacity-50 p-4 rounded-xl block">
                <span>
                  {lang === "en" ? `Arrival` : `Aankomst`}
                </span>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-5 w-5 text-slate-500 inline r-0`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
              <p className="font-sans" dangerouslySetInnerHTML={{ __html: item.aankomst }}/>

              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        
        <Disclosure as="div" className="mt-1">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex justify-between w-full font-inter font-bold bg-stone-200 bg-opacity-50 p-4 rounded-xl block">
                <span>
                  {lang === "en" ? `What is included?` : `Wat is inbegrepen?`}
                </span>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-5 w-5 text-slate-500 inline`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
              <p className="font-sans" dangerouslySetInnerHTML={{ __html: item.inbegrepen }}/>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>

        <Disclosure as="div" className="mt-1">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex justify-between w-full font-inter font-bold bg-stone-200 bg-opacity-50 p-4 rounded-xl block">
                <span>
                {lang === "en" ? `Facilities` : `Faciliteiten`}
                </span>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-5 w-5 text-slate-500 inline`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
              <p className="font-sans faciliteiten" dangerouslySetInnerHTML={{ __html: item.faciliteiten }} />
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>

        <Disclosure as="div" className="mt-1">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex justify-between w-full font-inter font-bold bg-stone-200 bg-opacity-50 p-4 rounded-xl block">
                <span>Entertainment</span>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-5 w-5 text-slate-500 inline`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
              <p className="font-sans entertainment" dangerouslySetInnerHTML={{ __html: item.entertainment }} />
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>

        <Disclosure as="div" className="mt-1">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex justify-between w-full font-inter font-bold bg-stone-200 bg-opacity-50 p-4 rounded-xl block">
                <span>
                {lang === "en" ? `Transport` : `Vervoer`}
                </span>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-5 w-5 text-slate-500 inline`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
              <p className="font-sans vervoer" dangerouslySetInnerHTML={{ __html: item.vervoer }} />
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>

        <Disclosure as="div" className="mt-1">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex justify-between w-full font-inter font-bold bg-stone-200 bg-opacity-50 p-4 rounded-xl block">
                <span>
                {lang === "en" ? `How to pay` : `Betalen`}
                </span>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-5 w-5 text-slate-500 inline`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
              <p className="font-sans betaalmogelijkheden" dangerouslySetInnerHTML={{ __html: item.betaalmogelijkheden }} />
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>


        <Disclosure as="div" className="mt-1">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex justify-between w-full font-inter font-bold bg-stone-200 bg-opacity-50 p-4 rounded-xl block">
                <span>
                {lang === "en" ? `Basic pack list` : `Basic paklijst`}
                </span>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-5 w-5 text-slate-500 inline`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
              <p className="font-sans paklijst" dangerouslySetInnerHTML={{ __html: item.paklijst }} />
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>

        <Disclosure as="div" className="mt-1">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex justify-between w-full font-inter font-bold bg-stone-200 bg-opacity-50 p-4 rounded-xl block">
                <span>
                {lang === "en" ? `Surfing` : `Surfen`}
                </span>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-5 w-5 text-slate-500 inline`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
              <p className="font-sans surfen" dangerouslySetInnerHTML={{ __html: item.surfen }} />
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>


        <Disclosure as="div" className="mt-1">
          {({ open }) => (
            <>
              <Disclosure.Button className="flex justify-between w-full font-inter font-bold bg-stone-200 bg-opacity-50 p-4 rounded-xl block">
                <span>
                {lang === "en" ? `General` : `Algemeen`}
                </span>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-5 w-5 text-slate-500 inline`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
              <p className="font-sans algemeen" dangerouslySetInnerHTML={{ __html: item.algemeen }} />
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    </div>
))}
</div>

{/* EIND PRAKTISCH */}



{surfvakantieNieuw.vergelijkbareSurfvakanties && surfvakantieNieuw.vergelijkbareSurfvakanties.length > 0 && (<div className="container p-2">{/* START VERGELIJKBARE SURFVAKANTIES */}
<h2 className="text-2xl sm:text-3xl my-2 uppercase text-center sm:text-left mt-5">
  {lang === "en" ? `Similar Surf Camps` : `Vergelijkbare Surfvakanties`}
</h2>
<div className="w-full flex justify-end my-2">
   <button className="border-2 font-sans rounded-full theme-prev bg-white">
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
   <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
 </svg>
 
   </button>
   
   <button className="border-2 font-sans rounded-xl theme-next bg-white">
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
   <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
 </svg>
 
   </button>
 
   </div>

   <Swiper
            slidesPerView={1}
            breakpoints={{
             640: {
               slidesPerView: 2,
             },
           }}
         spaceBetween={10}
         id="theme-swiper"
         cssMode={true}
         navigation={{
           nextEl: ".theme-next",
           prevEl: ".theme-prev"
         }}
         pagination={true}
         mousewheel={true}
         keyboard={true}
         modules={[Navigation, Mousewheel, Keyboard]}
         className="mySwiper"
       >


<div className="grid grid-cols-2 gap-4">
  {surfvakantieNieuw.vergelijkbareSurfvakanties.map(item => (
    <SwiperSlide>
  <div className="grid-item bg-stone-100 rounded-lg m-2 pb-5 hover:shadow-md transition duration-300 cursor-pointer">
<Link to={item.surfvakanties.uri}>

<img src={item.surfvakanties.featuredImage.node.publicUrl}  className="rounded-t-xl w-full overflow-hidden" alt="alt" />

<div className="flex justify-between absolute top-0 w-full">


  {item.surfvakanties.surfvakantieNieuw.hurryShout && (
            <div className="bg-sky-50 font-inter px-2 py-1 m-1 rounded-lg z-10 inline text-sm">
              <p className="font-inter inline">{item.surfvakanties.surfvakantieNieuw.hurryShout}</p>
            </div>
          )}

   
          {item.surfvakanties.surfvakantieNieuw.discount && (
            <div className="bg-orange-500 font-inter px-2 py-1 text-white m-1 rounded-lg z-10 text-sm">
              <p className="font-inter font-semibold inline">
              {lang === "en" ? `Promotion` : `Kortingsactie`}
              </p>
            </div>
          )}  

          </div>

            <div className="m-4">
          <div className="mt-2 -mb-2 text-xs font-inter text-slate-500 uppercase font-bold flex justify-between">
            
            <div>{ item.surfvakanties.surfvakantieNieuw.typeAccommodatie } { item.surfvakanties.surfvakantieNieuw.land }</div>
            <div>
                <p className="ml-4 text-sm font-bold text-slate-500">
                <svg aria-hidden="true" className="w-5 h-5 text-yellow-400 inline" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Rating star</title><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path></svg>
                {item.surfvakanties.surfvakantieNieuw.rating} / 5
                </p>
            </div>
          </div>
          
          
          <h4 className="text-lg font-inter font-semibold mb-2">{item.surfvakanties.title}</h4>
          <ul className="list-none font-inter font-sm">
          
          <li className="flex items-center my-1">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-5 h-5 -ml-6 inline text-slate-500">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
        </svg>

        <p className="ml-4  text-slate-500 text-sm">
              {item.surfvakanties.surfvakantieNieuw.inleidingLocatie}, {item.surfvakanties.surfvakantieNieuw.inleidingRegio}
                </p>
            </li>

            <li className="flex items-center my-1">
                <div className="text-slate-500 text-sm">
                <svg data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="w-5 h-5 -ml-6 -mt- inline">
  <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"></path>
</svg>
                  <p className="ml-4 inline">{item.surfvakanties.surfvakantieNieuw.inleidingVervoer}</p>
                </div>
              </li>

            <li className="flex items-center my-1">
<div className="text-slate-500 text-sm">
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 -ml-6 -mt- inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
</svg>


<p className="ml-4 inline">{item.surfvakanties.surfvakantieNieuw.inleidingOpen}</p>
</div>
</li>


<li className="flex items-center my-1">
<div className="text-slate-500 text-sm">
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 -ml-6 -mt- inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
</svg>


<p className="ml-4 inline">{item.surfvakanties.surfvakantieNieuw.extra}</p>
</div>
</li>




<li className="flex items-center my-1">
<div className="text-slate-500 text-sm">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 -ml-6 align-top inline">
  <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clipRule="evenodd" />
</svg>

<p className="ml-4 inline-block">
  
  {lang === "en" ? `Popular with: ` : `Populair bij: `}

{item.surfvakanties.surfvakantieNieuw.populair}</p>
</div>
</li>



<li className="flex items-center flex justify-end">
  <Link to={item.surfvakanties.link}>
<button className="bg-black text-white font-bold py-2 px-4 rounded-lg float-right">
  
  {lang === "en" ? `Discover` : `Ontdek`}
  </button>
</Link>
</li> 


          </ul>
          </div>

  </Link>
  </div>
  </SwiperSlide>
  ))}
</div>
</Swiper> 
</div>

)}







<div>
<div className="font-inter" id="reviews">

  
  
<h2 className="text-3xl my-4">SurfaWhile Reviews {totalReviews > 0 ? accommodations[0].node.data.Accommodation : ""}</h2>

{totalReviews === 0 ? (
  <p>
    {lang === "en" ? `There are no reviews available for this accommodation yet.` : `Er zijn nog geen reviews beschikbaar voor deze accommodatie.`}
  </p>
) : (
  <>    
    <div className="my-5 w-full bg-sky-200 font-inter p-5 rounded-lg shadow-md">
    <div className="flex justify-between items-center mb-2 bg-sky-200">
            <h3 className="text-2xl">
              {lang === "en" ? `Average Rating SurfaWhile Travelers` : `Gemiddelde Beoordeling SurfaWhile Reizigers`}
            </h3>
            <span className={`rounded-full ${calculationBgColor} p-6 text-xl font-bold text-white`}>{averageScores.Calculation}</span>
          </div>
          <p>
          {lang === "en" ? `Based on ${totalReviews} verified review(s)` : `Gebaseerd op ${totalReviews} geverifieerde reviews`}
          </p>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6  p-5">
        <RatingItem 
          title="Accommodatie" 
          percentage={Math.round(averageScores.Quality_Accommodation * 20)} 
       
          svgPath="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205l3 1m1.5.5l-1.5-.5M6.75 7.364V3h-3v18m3-13.636l10.5-3.819" 
        />
       
        <RatingItem 
          title="Sfeer" 
          percentage={Math.round(averageScores.Atmosphere * 20)} 
      
          svgPath="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" 
        />
        <RatingItem 
          title="Surfles" 
          percentage={Math.round(averageScores.Surf_Lessons * 20)} 
          
          svgPath="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" 
        />
        <RatingItem 
          title="Staff" 
          percentage={Math.round(averageScores.Staff * 20)} 
          
          svgPath="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" 
        />
        <RatingItem 
          title="Locatie" 
          percentage={Math.round(averageScores.Quality_Location * 20)}
 
          svgPath="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" 
        />
        <RatingItem 
          title="Prijs / kwaliteit" 
          percentage={Math.round(averageScores.Price_Quality * 20)} 
     
          svgPath="M14.25 7.756a4.5 4.5 0 100 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
        />
      </div>
      </div>
      
      <h3 className="text-2xl my-4">
        {lang === "en" ? `Verified Reviews by SurfaWhile Travelers` : `Geverifieerde Reviews door SurfaWhile Reizigers`}
      </h3>
      
      {accommodations.map(({ node }, index) => {
        const individualScoreColor = getColor(parseFloat(node.data.Calculation).toFixed(1));
        
        return (
          <div className="my-5 w-full bg-sky-200 font-inter p-5 rounded-lg shadow-md" key={index}>
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-2xl font-bold">{node.data.Name_Traveller}</h3>

              <span className={`rounded-full p-6 text-xl font-bold text-white ${calculationBgColor}`}>
                 {node.data.Calculation.toFixed(1)}
               </span>

            </div>
            
            <span className="text-sm font-semibold font-inter text-slate-500 mb-2 block">{node.data.Accommodation}</span>
            
            <p className="text-sm mb-2">
              <span className="font-bold">{node.data.Nationality} </span> - 
              <span className="font-bold">{node.data.Gender} </span> - 
              <span className="font-bold">{node.data.Age_Category} {lang === "en" ? `jaar` : `years old`}
 
              
              </span> - 
              <span className="font-bold">{node.data.Traveller_Type} </span> - 
              <span className="font-bold">{node.data.Surf_Level} </span> - 
              <span className="font-bold">{node.data.Period} </span>
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-2">
              <RatingItem 
                title="Accommodatie" 
                percentage={Math.round(node.data.Quality_Accommodation * 20)} 
                average={node.data.Quality_Accommodation.toFixed(1)}
                svgPath="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205l3 1m1.5.5l-1.5-.5M6.75 7.364V3h-3v18m3-13.636l10.5-3.819" 
              />
              <RatingItem 
                title="Sfeer" 
                percentage={Math.round(node.data.Atmosphere * 20)} 
                average={node.data.Atmosphere.toFixed(1)}
                svgPath="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" 
              />
              <RatingItem 
                title="Surfles" 
                percentage={Math.round(node.data.Surf_Lessons * 20)} 
                average={node.data.Surf_Lessons.toFixed(1)}
                svgPath="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" 
              />
              <RatingItem 
                title="Staff" 
                percentage={Math.round(node.data.Staff * 20)} 
                average={node.data.Staff.toFixed(1)}
                svgPath="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" 
              />
              <RatingItem 
                title="Locatie" 
                percentage={Math.round(node.data.Quality_Location * 20)} 
                average={node.data.Quality_Location.toFixed(1)}
                svgPath="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" 
              />
              <RatingItem 
                title="Prijs / kwaliteit" 
                percentage={Math.round(node.data.Price_Quality * 20)} 
                average={node.data.Price_Quality.toFixed(1)}
                svgPath="M14.25 7.756a4.5 4.5 0 100 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
              />
            </div>
            
            <p className="font-bold">
              {lang === "en" ? `The experience of ${node.data.Name_Traveller}` : `De ervaring van ${node.data.Name_Traveller}`}
            </p>
            <blockquote className="text-lg italic text-gray-700 border-l-4 border-gray-300 pl-4">
              <p className="font-inter">
                "{node.data.Experience}"
              </p>
            </blockquote>
            </div>
            );
          })}
        </>
      )}
    </div>
 



</div>{/* EINDE VERGELIJKBARE SURFVAKANTIES */}

</div>{/* EINDE MAIN COLUMN */}





<div className="sidebar hidden md:inline">
  
  {/* Prijzen en boeken */}



  {/* Pakketten */}

  {/* Betaalprocedure */}



  {surfvakantieNieuw.packages?.length > 0 && (
  <div id="packages" className="container p-4">
    <h3 className="text-2xl sm:text-3xl uppercase text-gray-800">
      {lang === "en" ? `Packages` : `Pakketten`}
    </h3>

    <p className="font-inter text-slate-500 mt-1">
      {lang === "en"
        ? `Click on the desired package below for prices and availability.`
        : `Klik op het gewenste pakket hieronder voor prijzen en beschikbaarheid.`}
    </p>

    <p className="font-inter mt-1 text-slate-500 p-4 bg-green-100 rounded-lg my-2 border-2 border-green-100">
      <b>{lang === "en" ? `Always included` : `Altijd gratis inbegrepen:`}</b>
      <ul className="list-none ml-4 mt-2 space-y-1">
        <li>✔ {lang === "en" ? `Our e-book worth € 9,99` : `Ons e-book t.w.v. € 9,99`}</li>
        <li>✔ {lang === "en" ? `€ 15,- shop credit` : `€ 15,- shoptegoed`}</li>
        <li>✔ {lang === "en" ? `Objective advice from our Surf & Travel Experts` : `Objectief advies van onze Surf & Travel Experts`}</li>
      </ul>
    </p>

    <div className="grid grid-cols-1 gap-4">
      {surfvakantieNieuw.packages.map((pkg) => (
         <a href={pkg.packageBlUrl} className="block">
        <details open key={pkg.packageTitle} className="mt-1 bg-stone-100 rounded-lg shadow-md border border-stone-200">
          <summary className="px-6 py-4 font-bold text-2xl cursor-pointer flex justify-between items-center font-oswald uppercase">
            {pkg.packageTitle}
          </summary>

          <div className="px-6 pb-6 space-y-4">
            <p className="font-inter text-slate-500" dangerouslySetInnerHTML={{ __html: pkg.packageIntroduction }} />

            <div>
              <h4 className="font-semibold mb-2 uppercase">{lang === "en" ? `Included:` : `Inclusief:`}</h4>
              <ul className="list-disc list-inside font-inter text-slate-500">
  {pkg.packageBody
    .split("\n")
    .filter(item => item.startsWith("<li>") && item.endsWith("</li>"))
    .map((item, idx) => (
      <li key={idx}>{removeHtmlTags(item)}</li>
    ))}
</ul>

            </div>

            <div>
              <h4 className="font-semibold mt-4 mb-2 uppercase">{lang === "en" ? `Optional:` : `Optioneel:`}</h4>
              <ul className="list-disc list-inside font-inter text-slate-500 mt-4">
  {pkg.packageOptional
    .split("\n")
    .filter(item => item.startsWith("<li>") && item.endsWith("</li>"))
    .map((item, idx) => (
      <li key={idx}>{removeHtmlTags(item)}</li>
    ))}
</ul>
            </div>

            <p className="font-inter text-slate-500" dangerouslySetInnerHTML={{ __html: pkg.packageFooter }} />

            <div className="mt-4">
              {pkg.discountPrice ? (
                <div className="font-inter font-bold">
                  <span className="line-through block">{pkg.packageFromPrice}</span>
                  <span className="text-red-500">{pkg.discountPrice}</span>
                </div>
              ) : (
                <div className="font-inter font-bold">{pkg.packageFromPrice}</div>
              )}
            </div>

            <div className="mt-6 text-right">
              <a href={pkg.packageBlUrl} className="inline-block bg-orange-500 text-white font-semibold py-2 px-6 rounded-full font-inter">
                {lang === "en" ? `All Dates & Prices` : `Alle Prijzen & Data`}
              </a>
              <p className="text-sm text-slate-500 mt-2 font-inter">{lang === "en" ? `No costs will be charged yet` : `Er worden nog geen kosten in rekening gebracht`}</p>
            </div>
          </div>
        </details>
        </a>
      ))}
    </div>
  </div>
)}



{surfvakantieNieuw.boekingsproces && surfvakantieNieuw.boekingsproces.length > 0 && (
  <div className="container p-4 mx-auto">
  <div className="font-inter mt-4 text-slate-500 p-4 bg-stone-100 rounded-lg my-2">
    <h3 className="text-2xl mb-4">
      {lang === "en" ? `Reserve & Book` : `Reserveren & Boeken`}
    </h3>
    <table className="table-auto w-full text-left">
      <tbody>
        {surfvakantieNieuw.boekingsproces.map((item, index) => (
          <>
      
            {item.reserveren && (
              <tr className="align-top" key={`reserveren-${index}`}>
                <td className="pr-4 w-8">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 text-green-500"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                    />
                  </svg>
                </td>
                <td>
                  <b>
                    {lang === "en" ? `Reserve:` : `Reserveren:`}
                    </b>
                  {item.reserveren}
                </td>
              </tr>
            )}

            
            {item.betaaltermijnen && (
              <tr className="align-top" key={`betaaltermijnen-${index}`}>
                <td className="pr-4 w-8">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 text-green-500"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M14.25 7.756a4.5 4.5 0 1 0 0 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                </td>
                <td>
                  <b>
                    {lang === "en" ? `Payment terms` : `Betaaltermijnen: `}
                    </b>
                  {item.betaaltermijnen}
                </td>
              </tr>
            )}

          
            {item.betaalmethoden && (
              <tr className="align-top" key={`betaalmethoden-${index}`}>
                <td className="pr-4 w-8">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 text-green-500"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
                    />
                  </svg>
                </td>
                <td>
                  <b> 
                  {lang === "en" ? `Payment methods:` : `Betaalmethoden: `}
                  </b>
                  {item.betaalmethoden}
                </td>
              </tr>
            )}
          </>
        ))}
      </tbody>
    </table>
  </div>
  </div>
)}



</div>

</div>
</div>




<div className="w-full">
  <nav 
  
  className="w-full px-0 sm:px-10 lg:px-20 bg-stone-200 flex justify-end fixed bottom-0 w-full h-16 shadow-lg z-40">
    



    <span className="flex items-center">
      <div className="font-inter font-semibold text-slate-500 text-sm lg:text-sm mr-2 whitespace-nowrap">
        <b>
        {lang === "en" ? `From € ${surfvakantieNieuw.inleidingPrijs} ` : `v.a. € ${surfvakantieNieuw.inleidingPrijs} `}
          </b>
      </div>
      <a href={surfvakantieNieuw.blUrl}>
      <button className="bg-orange-500 text-white font-semibold font-inter py-1.5 px-3 sm:py-2 sm:px-6 rounded-full hover:bg-amber-600 my-2 mr-2 flex items-center">
          {lang === "en" ? `Start Booking  ` : `Start Boeking `}
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mx-1">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
          </svg>
        </button>
      </a>
    </span>

  </nav>
</div>

</div>

  </Layout>
  
  );
};


export const pageQuery = graphql`
query($id: String!,$title: String!, $land: String!) {
  wpSurfvakantie(id: { eq: $id }) {
    databaseId
    title
    uri
    link
    slug
    author{
        node {
          firstName
          lastName
          description
          seo {
            social {
              linkedIn
            }
          }
          jobTitle{
            jobTitle
          }
      }
    }
    surfvakantieNieuw {
    categories
     customOrderTaal
     customOrderFamilies
     land
     rating
     numberOfReviews
     typeAccommodatie
     video
     inleidingVervoer
     inleidingLocatie
     inleidingRegio
     inleidingMinimumleeftijd
     inleidingOpen
     inleidingSurfles
     inleidingTypenVerblijf
     inleidingVoertaal
     inleidingTypenReiziger
     inleidingPrijs
     extra
     adres
     mapsUrl
     vervoer
     blUrl
     dreamseaEarlyBird
     boekingsproces {
      reserveren
      betaaltermijnen
      betaalmethoden
     }
     packages {
      packageTitle
      packageIntroduction
      packageBody
      packageOptional
      packageFooter
      packageFromPrice
      discountPrice
      packageBlUrl
    }
     discount
     hurry
     hoogtepunten {
      hoogtepuntBody1
      hoogtepuntBody2
      hoogtepuntBody3
      hoogtepuntHeader1
      hoogtepuntHeader2
      hoogtepuntHeader3
    }
    languageSchool
    accommodatieInleiding
    accommodaties {
      naam
      typering
      vanafprijs
      beschrijving
      gallery
      {
        publicUrl
        localFile{
          childImageSharp {
            gatsbyImageData(
            width: 400
            height: 300
             placeholder: BLURRED
             formats: [AUTO, WEBP, AVIF]

             )
            }
          }
      }
      foto {
        publicUrl
        localFile{
        childImageSharp {
          gatsbyImageData(
           height: 400
           width: 600
           placeholder: BLURRED
           formats: [AUTO, WEBP, AVIF]
           )
          }
        }
      }
    }
    surfenInleiding
    surfen {
      naam
      typering
      vanafprijs
      beschrijving
      foto {
        publicUrl
        localFile{
        childImageSharp {
          gatsbyImageData(
           height: 400
           width: 600
           placeholder: BLURRED
           formats: [AUTO, WEBP, AVIF]
           )
          }
        }
      }
    }
    activiteitenInleiding
    activities {
      naam
      typering
      vanafprijs
      beschrijving
      foto {
        publicUrl
        localFile{
        childImageSharp {
          gatsbyImageData(
           height: 400
           width: 600
           placeholder: BLURRED
           formats: [AUTO, WEBP, AVIF]
           )
          }
        }
      }
    }
    maaltijdenInleiding
    maaltijden {
      naam
      typering
      vanafprijs
      beschrijving
      foto {
        publicUrl
        localFile{
        childImageSharp {
          gatsbyImageData(
           height: 400
           width: 600
           placeholder: BLURRED
           formats: [AUTO, WEBP, AVIF]
           )
          }
        }
      }
    }
    praktisch {
      aankomst
      inbegrepen
      vervoer
      betaalmogelijkheden
      paklijst
      faciliteiten
      entertainment
      surfen
      algemeen
    }
    vergelijkbareSurfvakanties {
      surfvakanties {
        ... on WpSurfvakantie {
          id
          title
          uri
          featuredImage {
            node {
              publicUrl
              id
              link
              uri
              localFile {
                id
                childImageSharp {
                  gatsbyImageData(
                    width: 600
                    height: 400
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
          }
          surfvakantieNieuw {
            land
            inleidingLocatie
            inleidingRegio
            inleidingOpen
            rating
            categories
            typeAccommodatie
            customOrder
            discount
            populair
            extra
            hurryShout
            inleidingVervoer
          }
        }
      }
    }
    prijslijstInleiding
    prijslijstHeader1
    prijslijstHeader2
    prijslijstHeader3
    prijslijstHeader4
    prijslijsten {
      startdatum
      gedeeld
      prijsPrive1p
      prijsPrive2p
    }
    addonsInleiding
    addons {
        prijs
        item
    }
    gallery1: gallery {
      id
      publicUrl
      localFile {
        id
        childImageSharp {
          gatsbyImageData(
            width: 900
            height: 600
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
            layout: CONSTRAINED
          )
        }
      }
    }
    gallery2: gallery {
      id
      publicUrl
      localFile {
        id
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
            layout: CONSTRAINED
          )
        }
      }
    }
      introduction
      ourVision
      destination
      destinationLink
    }
    seo {
      title
      metaDesc
    }
    featuredImage {
      node {
        publicUrl
        id
        link
        localFile {
          id
          childImageSharp {
            gatsbyImageData(
             width: 1200
             placeholder: BLURRED
             formats: [AUTO, WEBP, AVIF]
             )
         }
        }
      }
    }
  }

  # ✅ Voeg defaultSurfvakantie toe met de Nederlandse variant
  defaultSurfvakantie: allWpSurfvakantie(
    filter: { 
      title: { eq: $title }
      language: { code: { eq: NL } }
    }
  ) {
    edges {
      node {
        databaseId
        id
        title
        surfvakantieNieuw {
          gallery {
            id
            publicUrl
            localFile {
              id
              childImageSharp {
                gatsbyImageData(
                  width: 900
                  height: 600
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                  layout: CONSTRAINED
                )
              }
            }
          }
          accommodaties {
            gallery {
              publicUrl
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 400
                    height: 300
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
            foto {
              publicUrl
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    height: 400
                    width: 600
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
          }
        }
      }
    }
  }
  allWpSurfvakantie(
    filter: {
      surfvakantieNieuw: {
        land: { eq: $land }
        categories: { nin: ["group"] }
      }
      parentId: { ne: "null" }
    }
  ) {
    edges {
      node {
        id
        title
        uri
        featuredImage {
          node {
            publicUrl
            id
            link
            uri
            localFile {
              id
              childImageSharp {
                gatsbyImageData(
                  width: 600
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
        }
        surfvakantieNieuw {
          land
          inleidingLocatie
          inleidingRegio
          inleidingOpen
          rating
          categories
          typeAccommodatie
          customOrder
          discount
          populair
          extra
        }
      }
    }
  }
  allAirtable(filter: { data: { Accommodation: { eq: $title } } }) {
    edges {
      node {
        data {
          Name_Traveller
          Age_Category
          Nationality
          Accommodation
          Gender
          Period
          Experience
          Price_Quality
          Quality_Accommodation
          Quality_Location
          Surf_Lessons
          Atmosphere
          Staff
          Price_Quality
          Surf_Level
          Calculation
          Traveller_Type
        }
      }
    }
  }
}
`
export default SurfvakantieTemplate;